import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// You can place this CSS in your App.css or a styled-component
const styles = {
  navbar: {
    backgroundColor: "rgba(255, 255, 255, 0.95)", // Semi-transparent white
    backdropFilter: "blur(10px)", // Blur effect behind the nav
    transition: "all 0.3s ease-in-out",
  },
  brandText: {
    fontFamily: "'Poppins', sans-serif", // Ensure you have a nice font loaded
    letterSpacing: "-0.5px",
    color: "#333",
  },
  navLink: {
    position: "relative",
    color: "#555",
    fontWeight: "600",
  }
};

export const Navigation = () => {
  // Smooth scroll handler
  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <style>
        {`
          /* Modern Hover Animation for Links */
          .nav-link-modern {
            position: relative;
            transition: color 0.3s ease;
          }
          .nav-link-modern::after {
            content: '';
            position: absolute;
            width: 0;
            height: 2px;
            bottom: 0;
            left: 50%;
            background-color: #0d6efd; /* Bootstrap primary blue or your brand color */
            transition: all 0.3s ease;
            transform: translateX(-50%);
          }
          .nav-link-modern:hover::after {
            width: 100%;
          }
          .nav-link-modern:hover {
            color: #0d6efd !important;
          }
        `}
      </style>

      <Navbar 
        expand="lg" 
        fixed="top" 
        className="shadow-sm py-3" 
        style={styles.navbar}
      >
        <Container>
          {/* Logo and Title Container */}
          <Navbar.Brand 
            href="#page-top" 
            className="d-flex align-items-center"
            onClick={(e) => handleScroll(e, "page-top")}
          >
            <img
              src="/img/sari_logo.png"
              alt="Sari-Sari Logo"
              style={{ height: "40px", objectFit: "contain" }}
            />
            {/* Title next to logo */}
            <span className="ms-2 fs-3 fw-bold" style={styles.brandText}>
              Sari-Sari
            </span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0" />
          
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto gap-4 align-items-center">
              {['About', 'Products', 'Promotions', 'Contact'].map((item) => {
                const targetId = item.toLowerCase() === 'products' ? 'services' : 
                                 item.toLowerCase() === 'promotions' ? 'portfolio' : 
                                 item.toLowerCase();
                return (
                  <Nav.Link 
                    key={item}
                    onClick={(e) => handleScroll(e, targetId)}
                    className="nav-link-modern fs-4"
                    style={styles.navLink}
                  >
                    {item}
                  </Nav.Link>
                );
              })}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};